import { ForcedUpdateType } from 'src/shared/types/src';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: ForcedUpdateType = {
    appVersion: '',
    isForceUpdateRequired: false
}

const forceUpdateSlice = createSlice({
    name: 'forceUpdateSlice',
    initialState,
    reducers: {
        setForceUpdateOptions: (state, action: PayloadAction<ForcedUpdateType>) => {
            const { appVersion, isForceUpdateRequired } = action.payload;
            state.appVersion = appVersion;
            state.isForceUpdateRequired = isForceUpdateRequired;
        },
        resetForcedUpdateOptions: () => {
            return initialState;
        }
    }
});

export const ForceUpdateActions = forceUpdateSlice.actions;
export default forceUpdateSlice.reducer;
